import * as moment from 'moment';
import React from 'react';

export function formatDate(date: Date | moment.Moment | string | undefined | null, mode: 'date' | 'time' | 'datetime') {
  if (!date) {
    return '-';
  }
  switch (mode) {
    case 'date':
      return moment(date).format('L');
    case 'time':
      return moment(date).format('LTS');
    case 'datetime':
      return moment(date).format('L LTS');
    default:
      return moment(date).format('L LTS');
  }
}

interface FormatDateProps {
  date: Date | moment.Moment | string;
  mode: 'date' | 'time' | 'datetime';
}

export const FormatDate: React.FunctionComponent<FormatDateProps> = props => {
  // eslint-disable-next-line react/prop-types
  const { date, mode } = props;
  return <span>{formatDate(date, mode)}</span>;
};



// WEBPACK FOOTER //
// ./src/components/table/Date.tsx